import React, { createContext, useContext, useState } from 'react';

const SubscriptionContext = createContext();

export const useSubscription = () => {
  const context = useContext(SubscriptionContext);
  if (!context) {
    throw new Error('useSubscription must be used within SubscriptionProvider');
  }
  return context;
};

export const SubscriptionProvider = ({ children, initialStep = 0 }) => {
  const [step, setStep] = useState(initialStep);
  const [subscriptionType, setSubscriptionType] = useState('');
  const [moduleType, setModuleType] = useState('');
  const [module, setModule] = useState(''); 
  const [duration, setDuration] = useState('');
  const [country, setCountry] = useState('');
  const [error, setError] = useState('');
  
  // Form validation state
  const [formErrors, setFormErrors] = useState({});
  const [isFormValid, setIsFormValid] = useState(false);

  const steps = [
    { label: 'Subscription Type', key: 'type' },
    { label: 'Module Type', key: 'module_type' },
    { label: 'Duration & Country', key: 'duration_country' },
    { label: 'Pricing & Configuration', key: 'pricing_config' } 
  ];

  const resetSubscription = () => {
    setStep(0);
    setSubscriptionType('');
    setModuleType('');
    setModule('');
    setDuration('');
    setCountry('');
    setError('');
    setFormErrors({});
    setIsFormValid(false);
  };

  const goToStep = (stepIndex) => {
    if (stepIndex >= 0 && stepIndex < steps.length) {
      setStep(stepIndex);
      setError('');
    }
  };

  // Update form validation state
  const updateFormValidation = (errors, isValid) => {
    setFormErrors(errors);
    setIsFormValid(isValid);
  };

  const value = {
    step,
    steps,
    subscriptionType,
    moduleType,
    module,
    duration,
    country,
    error,
    formErrors,
    isFormValid,
    setStep,
    setSubscriptionType,
    setModuleType,
    setModule,
    setDuration,
    setCountry,
    setError,
    goToStep,
    resetSubscription,
    updateFormValidation
  };

  return (
    <SubscriptionContext.Provider value={value}>
      {children}
    </SubscriptionContext.Provider>
  );
};
